var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjscomputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 10,
    fill: "#FBBF30",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n8kd91pq0a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wp1xo7kdyb)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M34.418 16.55c1.772 0 3.16 0 4.277.091 1.137.093 2.076.285 2.926.719a7.427 7.427 0 0 1 3.246 3.245c.433.85.625 1.79.718 2.926.091 1.117.091 2.506.091 4.277v.087c0 1.772 0 3.161-.09 4.278-.094 1.137-.286 2.076-.72 2.926a7.427 7.427 0 0 1-3.245 3.246c-.85.433-1.79.625-2.926.718-1.116.091-2.505.091-4.277.091h-2.95v2.369c.807.056 1.61.183 2.4.38l2.033.51a.969.969 0 1 1-.47 1.879l-2.034-.509a11.948 11.948 0 0 0-5.795 0l-2.034.509a.969.969 0 1 1-.47-1.88l2.034-.508a13.88 13.88 0 0 1 2.399-.381v-2.369h-2.95c-1.772 0-3.161 0-4.277-.091-1.137-.093-2.076-.285-2.926-.718a7.427 7.427 0 0 1-3.246-3.246c-.433-.85-.626-1.79-.719-2.926-.09-1.117-.09-2.506-.09-4.278v-.086c0-1.772 0-3.161.09-4.278.093-1.136.286-2.076.719-2.926a7.427 7.427 0 0 1 3.245-3.245c.85-.434 1.79-.626 2.927-.719 1.116-.091 2.505-.091 4.277-.091h7.837z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.418 16.55c1.772 0 3.16 0 4.277.091 1.137.093 2.076.285 2.926.719a7.427 7.427 0 0 1 3.246 3.245c.433.85.625 1.79.718 2.926.091 1.117.091 2.506.091 4.277v.087c0 1.772 0 3.161-.09 4.278-.094 1.137-.286 2.076-.72 2.926a7.427 7.427 0 0 1-3.245 3.246c-.85.433-1.79.625-2.926.718-1.116.091-2.505.091-4.277.091h-2.95v2.369c.807.056 1.61.183 2.4.38l2.033.51a.969.969 0 1 1-.47 1.879l-2.034-.509a11.948 11.948 0 0 0-5.795 0l-2.034.509a.969.969 0 1 1-.47-1.88l2.034-.508a13.88 13.88 0 0 1 2.399-.381v-2.369h-2.95c-1.772 0-3.161 0-4.277-.091-1.137-.093-2.076-.285-2.926-.718a7.427 7.427 0 0 1-3.246-3.246c-.433-.85-.626-1.79-.719-2.926-.09-1.117-.09-2.506-.09-4.278v-.086c0-1.772 0-3.161.09-4.278.093-1.136.286-2.076.719-2.926a7.427 7.427 0 0 1 3.245-3.245c.85-.434 1.79-.626 2.927-.719 1.116-.091 2.505-.091 4.277-.091h7.837z",
    stroke: "url(#yl8jcbu09c)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M29.531 34.31c0 .535.434.97.969.97h7.75a.969.969 0 0 0 0-1.938H30.5a.969.969 0 0 0-.969.968zm-4.198 0a1.292 1.292 0 1 1-2.583 0 1.292 1.292 0 0 1 2.583 0z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yl8jcbu09c",
    x1: 15.322,
    y1: 16.55,
    x2: 43,
    y2: 46.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n8kd91pq0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 15)",
    d: "M0 0h31v31H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wp1xo7kdyb",
    x: -9.428,
    y: -8.2,
    width: 79.853,
    height: 77.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2483"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2483",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjscomputer);
export default __webpack_public_path__ + "static/media/Bootcamp js computer.3f4abfa3ceda3ded64fb95b096a0f9c3.svg";
export { ForwardRef as ReactComponent };